import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useHistory } from 'react-router-dom';

import LoginNavBar from '../navigation/LoginNavBar';

import Button from '../components/Button';

import '../css/login.css';

const LoginPage = ({
  dispatch,
  isInitialLogin,
  loginResult,
  handleChange,
  handleSubmit,
  grantingLower,
  navBarWidth,
  navBarHeight,
  navBarActive,
}) => {
  const style = navBarActive ? {} : { top: navBarHeight };

  const [ grantLowerModal, setGrantLowerModal ] = useState(null);
  const modalSizeX = "768px";
  const modalSizeY = "256px";

  const [ finetune, setFinetune ] = useState({
    finetuneX: window.innerWidth,
    finetuneY: window.innerHeight,
  });

  const handleResize = () => {
    setFinetune({
      finetuneX: window.innerWidth,
      finetuneY: window.innerHeight
    });
  }
  
  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, [window.innerWidth, window.innerHeight]);

  const history = useHistory();

  useEffect(() => {
    if (grantingLower)
      setGrantLowerModal(
        <div id='overlay' className='overlay' style={{ width: finetune.finetuneX, height: finetune.finetuneY}}>
          <div id='modal' className='modal-signup flex justify-center items-center' style={{ width: modalSizeX, height: modalSizeY }}>
            <div className='white blinking'>Granting ETH for the account with a lower amount...</div>
          </div>
        </div>
      )
    else
      setGrantLowerModal(null);
  }, [grantingLower]);

  return (
    <div className='times-new-roman h-100'>
      {grantLowerModal}
      <div className='flex flex-row-reverse-l flex-column-reverse justify-end justify-start-l' style={{ minHeight: '100vh' }}>
        <div className='flex-auto-l bg-navy' style={{ width: finetune.finetuneX, height: finetune.finetuneY }}>
          <main className='pa0-l'>
            <div className='relative' style={style}>
              <div className='mt5 flex flex-column flex-wrap items-center bg-navy' style={{ overflowY: 'auto' }}>
                <div className='bg-white pa3'>
                  <div className='flex justify-center items-center pa3 times-new-roman fw4 f3 charcoal'>Log In to Your Account</div>
                  { loginResult !== null && !loginResult && <div className='tc mt3 mb3 pt3 pb3 border-red bg-red-100' >
                      <span className='text-red-500'>Invalid login.</span>
                    </div> }
                  <div className='flex flex-column'>
                    <form className='flex flex-column' onSubmit={handleSubmit}>
                      <div className='charcoal f5 mb2'>EMAIL</div>
                      <input
                        type="text"
                        name="emailAddress"
                        placeholder="Specify your e-mail address"
                        onChange={handleChange}
                        className='b--gray mb4'
                        style={{ width: '400px', borderStyle: 'solid', borderWidth: '1px', padding: '8px', outline: '#FF0000' }}
                      />
                      <div className='charcoal f5 mb2'>PASSWORD</div>
                      <input
                        type="password"
                        name="password"
                        placeholder="Specify your password"
                        autoComplete="on"
                        onChange={handleChange}
                        className='b--gray mb4'
                        style={{ width: '400px', borderStyle: 'solid', borderWidth: '1px', padding: '8px', outline: '#FF0000' }}
                      />
                      <Button type="submit" className='times-new-roman mb4' style={{ padding: '8px' }} >SUBMIT</Button>
                   </form>
                  </div>
                </div>
                <p className='times-new-roman white'>Not yet a member? <button className='times-new-roman white underline' onClick={() => history.push("/signup")}>Sign up</button></p>
              </div>
            </div>
          </main>
        </div>
      { navBarActive
      ? <div className='flex-none-l z-4 navbar-container bg-navy-nav'>
        <LoginNavBar />
          </div>
       : <div className='fixed z-4 navbar-container flex-none-l bg-navy-nav' style={{ width: navBarWidth, height: navBarHeight }}>
         <LoginNavBar />
        </div> }
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  isInitialLogin: state.login.isInitialLogin,
  loginResult: state.login.loginResult,
  grantingLower: state.login.grantingLower,
  navBarWidth: state.navigation.navBarWidth,
  navBarHeight: state.navigation.navBarHeight,
  navBarActive: state.navigation.navBarActive
});

export default connect(mapStateToProps)(LoginPage);
